import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPopupUsers: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.userName !== undefined) {
			queryStr = objectToQuerystring({
				userName: searchParams.userName,
				deptName: searchParams.deptName,
				remark: searchParams.remark,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/comm/commpopup/userPopup/v1/users` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
